export enum MaterialType {
  WoodPlastic = 'wood_plastic',
  PaintFabric = 'paint_fabric',
}

export enum WIPType {
  WIPCar = 'wip_car',
  WIPRobot = 'wip_robot',
  WIPDoll = 'wip_doll',
}

export enum ProductType {
  ToyCar = 'toy_car',
  Robot = 'robot',
  LuxuryDoll = 'luxury_doll',
}

export interface ProductInfo {
  type: ProductType;
  label: string;
  color: number;
  wipType: WIPType;
  material: MaterialType;
  shape: 'rect' | 'square' | 'circle';
}

export const Products: Record<ProductType, ProductInfo> = {
  [ProductType.ToyCar]: {
    type: ProductType.ToyCar,
    label: 'CAR',
    color: 0xff4444,
    wipType: WIPType.WIPCar,
    material: MaterialType.WoodPlastic,
    shape: 'rect',
  },
  [ProductType.Robot]: {
    type: ProductType.Robot,
    label: 'ROBOT',
    color: 0x888888,
    wipType: WIPType.WIPRobot,
    material: MaterialType.WoodPlastic,
    shape: 'square',
  },
  [ProductType.LuxuryDoll]: {
    type: ProductType.LuxuryDoll,
    label: 'DOLL',
    color: 0xff69b4,
    wipType: WIPType.WIPDoll,
    material: MaterialType.PaintFabric,
    shape: 'circle',
  },
};

export const WIPToProduct: Record<WIPType, ProductType> = {
  [WIPType.WIPCar]: ProductType.ToyCar,
  [WIPType.WIPRobot]: ProductType.Robot,
  [WIPType.WIPDoll]: ProductType.LuxuryDoll,
};
